import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setCompanyHeader } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CompanyContext = createContext(null);

export function CompanyProvider({ children }) {
  const { user } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [currentId, setCurrentId] = useState(null);
  const [ready, setReady] = useState(false);

  const refreshCompanies = useCallback(async () => {
    const res = await api.get("/companies");
    setCompanies(res.data);
    return res.data;
  }, []);

  useEffect(() => {
    if (!user) {
      setReady(false);
      return;
    }
    (async () => {
      try {
        const list = await refreshCompanies();
        const saved = localStorage.getItem("company_id");
        const initial = list.find((c) => c.id === saved) ? saved : list[0]?.id;
        setCurrentId(initial);
        setCompanyHeader(initial);
      } catch (e) {
        // ignore
      } finally {
        setReady(true);
      }
    })();
  }, [user, refreshCompanies]);

  const switchCompany = (id) => {
    setCurrentId(id);
    setCompanyHeader(id);
    localStorage.setItem("company_id", id);
  };

  const current = companies.find((c) => c.id === currentId) || null;

  return (
    <CompanyContext.Provider
      value={{ companies, current, currentId, switchCompany, ready, refreshCompanies }}
    >
      {children}
    </CompanyContext.Provider>
  );
}

export const useCompany = () => useContext(CompanyContext);
